import { type ToastContent, type ToastOptions, toast } from 'react-toastify';

import classNames from 'classnames';

type ToastStatus = 'success' | 'error' | 'info' | 'warning';

type PersistentToastOptions = Omit<ToastOptions, 'toastId'> & {
  toastId: string;
  status?: ToastStatus;
};

const toastByStatus: Record<ToastStatus, typeof toast.success> = {
  success: toast.success,
  error: toast.error,
  info: toast.info,
  warning: toast.warn,
};

export const showPersistentToast = (message: ToastContent, options: PersistentToastOptions) => {
  const {
    toastId,
    status = 'success',
    autoClose = false,
    closeButton = true,
    draggable = true,
    className,
    ...rest
  } = options;
  toast.dismiss(toastId);
  const computedClassName = closeButton === false ? classNames('no-dismiss', className).trim() : className;
  return toastByStatus[status](message, {
    toastId,
    autoClose,
    closeButton,
    draggable,
    className: computedClassName || undefined,
    ...rest,
  });
};

export const dismissToastById = (toastId: string) => {
  toast.dismiss(toastId);
};
